import React, { useMemo } from "react";

import { useDispatch, useSelector } from "react-redux";
import {
  RideGlUserSolid,
  RideTextField,
} from "@rimac-seguros/ride-system-components";

import { handleInputPercentage, setErrorPercentage } from "@/utils/beneficiary-utils";
import { getDocumentType } from "@/constants/list-document-type";
import { formatAndMaskFullName, formatFullName } from "@/utils/format-name";
import { updateBeneficiaries } from "@/redux/actions/beneficiaries";

import "./styles.scss";
import helpers from '@/utils/helpers'

export const DetailBeneficiary = ({
  index,
  register,
  prefixControl,
  prefixError,
  errors,
  getValues,
  setError,
  clearErrors,
  trigger,
}) => {
  const isVE = helpers.validateVidaEndosable();
  const { beneficiaries } = useSelector((state) => state.beneficiaries);
  const { relationshipList } = useSelector((state) => state.global);

  const beneficiary = beneficiaries?.[index];
  
  const dispatch = useDispatch();
  const fullNameFormatter = isVE ? formatAndMaskFullName : formatFullName;

  const disabledEdit = useMemo(() => {
    return getValues("beneficiaries").some((_) => _.status === 0);
  }, [getValues()]);


  const percentComplete = useMemo(() => {
    return getValues("beneficiaries")
      .filter((_) => _.status === 1)
      .reduce((acc, field) => {
        return acc + Number(field.percentage);
      }, 0);
  }, [getValues()]);
  
  const onHandleBlurPercentage = (e) => {
    const value = e.target.value;

    if (value) {
      const newList = beneficiaries.map((_, i) => {
        return i === index ? { ..._, percentage: value } : _;
      });
      dispatch(updateBeneficiaries([...newList]));
    }

    if (percentComplete > 100) {
      setErrorPercentage(setError, getValues);
      return;
    }

    (errors.beneficiaries || []).forEach((error, idx) => {
      if (error?.percentage?.type === "invalidExceeded") {
        clearErrors(`beneficiaries.${idx}`);
        trigger(`beneficiaries.${idx}.percentage`);
      }
    });
  };

  const getRelationship = useMemo(() => {
    return relationshipList.find((_) => _.id === Number(beneficiary?.relationship))?.descripcion;
  }, [relationshipList, beneficiary]);

  return (
    <div className="flex flex-col gap-ride-gl-spacing-2xlarge lg:gap-ride-gl-spacing-3xlarge">
      <div className="flex border-b gap-ride-gl-spacing-large pb-ride-gl-spacing-2xlarge border-ride-sys-color-border-default lg:pb-ride-gl-spacing-3xlarge">
        <RideGlUserSolid size="medium" className="hidden mt-1 lg:block" />
        <div className="flex flex-col gap-ride-gl-spacing-medium lg:gap-ride-gl-spacing-large">
          <h4 className="ride-sys-text-paragraph-large-bold-short lg:ride-sys-text-title-2xlarge-default">
            {fullNameFormatter(beneficiary?.names, beneficiary?.lastName, beneficiary?.surName)}
          </h4>
          <span className="ride-sys-text-label-small-regular lg:ride-sys-text-paragraph-medium-regular-short">
            {getRelationship} - {getDocumentType(beneficiary?.documentType)?.label}{" "}
            {beneficiary?.documentNumber}
          </span>
        </div>
      </div>
      <div className="flex justify-between">
        <span className="ride-sys-text-label-small-semibold lg:ride-sys-text-label-medium-semibold modal-ab_text-percentage">
          Porcentaje de participación
        </span>
        <RideTextField
          {...register(`${prefixControl}.percentage`, {
            required: true,
            validate: (e) =>
              (Number(e) > 0 && Number(e) <= 100) || "Porcentaje inválido",
            onBlur: (e) => onHandleBlurPercentage(e),
          })}
          aria-required
          autoComplete="off"
          size="medium"
          suffix="%"
          disabled={disabledEdit}
          onInput={handleInputPercentage}
          error={!!prefixError?.percentage}
          errorMessage={prefixError?.percentage?.message || "Porcentaje inválido"}
          className="modal-ab_field-percentage"
        />
      </div>
    </div>
  );
};
